import { Stack, useTheme } from "@mui/material";
import type { FC } from "react";
import type { PortfolioDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { DetailRow } from "web_myplann/Portfolio/Components/Redesign/Detail/DetailRow";
import { DetailSectionHeader } from "web_myplann/Portfolio/Components/Redesign/Detail/DetailSectionHeader";
import { dateFormatter } from "web_myplann/Shared/Utils/dateFormatters";

const PageResources = Resources.PortfolioDetail;

type Props = {
	baseData: Pick<PortfolioDetailResponseDTO, "signedAt" | "startAt" | "endAt">;
	fixationEndDate?: string | null;
};

export const LoanAllBasicInfoDetails: FC<Props> = ({
	baseData,
	fixationEndDate,
}) => {
	const { t } = useResource();
	const theme = useTheme();

	const hasDetails =
		baseData.signedAt || baseData.startAt || baseData.endAt || fixationEndDate;

	if (!hasDetails) {
		return null;
	}

	return (
		<>
			<DetailSectionHeader
				title={t(Resources.DataCard.BasicInfo.additionalInfo)}
			/>
			<Stack bgcolor={theme.palette.background.paper}>
				<DetailRow
					label={t(PageResources.SharedLabels.signDate)}
					value={dateFormatter(baseData.signedAt)}
				/>
				<DetailRow
					label={t(PageResources.SharedLabels.beginDate)}
					value={dateFormatter(baseData.startAt)}
				/>
				<DetailRow
					label={t(PageResources.SharedLabels.endDate)}
					value={dateFormatter(baseData.endAt)}
				/>
				<DetailRow
					label={t(PageResources.LoanForBusiness.endOfFixation)}
					value={dateFormatter(fixationEndDate)}
				/>
			</Stack>
		</>
	);
};
